<template>
     <v-card>
         <v-card-title>
            <h3>Patch 1.1: The Gear Update</h3>
            <v-spacer/><sub>March 18th, 2022</sub>
        </v-card-title>
        <v-card-text style="color:black; font-size:0.9rem">
            <br/>The big thing for this patch is "Gear", which is going to open a lot of routes for GM's to design their encounters, and for players to experience new kinds of interesting gameplay. Tagged along in this patch as always is a few more various perks from various classes, as well as some minor perk changes.

            <br/><br/><h4 style="color:cornflowerblue">Gear Items:</h4
            >Gear items are a whole new type of item, but still fall into the supplies category, so players will gain a small amount, but will be able to share them among each other. Gear items are single use items that will replace the uses of mundane gear and minor wonderous items that would exist in a normal game.

            <br/><br/>-Gear comes in 5 types: Ammunition, Grenades, Blanches, Utility, and Implements.

            <br/><br/>-There are 48 new gear items, and 56 variant items, that are modified gear items for specific skills or specific metamagic feats for rods. Check them all out in the in games item tab!         
            
            <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                <div style="text-align:center; font-size:20px; color:cornflowerblue">
                See More!
                </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <h4 style="color:cornflowerblue">Gear Items and Types Summary:</h4>
                    <p>
                        <ul>
                            <li><b>Ammunition:</b> can be used with different ranged weapons for some added utility for ranged characters which are struggling in the current Akashic Paths meta</li>
                            <li><b>Grenades:</b> Grenades are a big change for akashic paths balancing, since they can be used by players to overcome common challenges that can be difficult for a party to deal with normally such as invisibility and flying creatures. </li>
                            <li><b>Blanches:</b> Blanches are another way to overcome common challenges in akashic paths, they can be applied to weapons and last a set amount of attacks (even through floor transitions) to overcome certain types of DR while also providing a damage buff when attacking creatures of specific types.</li>
                            <li><b>Utility:</b> This includes lots of adventuring gear that is generally useful to players, such as tools for dealing with skill checks players haven't optimized for, gear for location and grabbing treasure, and for getting past mundane obsticles such as walls and holes.</li>
                            <li><b>Implements:</b> Implements are minor magical items that can be used up to provide buffs to spells, such as helping overcoming resistances, and metamagic rods for one time metamagic uses.</li>
                        </ul>
                    </p>
                    <h4 style="color:cornflowerblue">How to Obtain Gear in Game:</h4>
                    <p
                        >Gear will drop from gold piles, and can also be seperately bought in encounters, and also from the store, including specific gear items, to pick up those much needed items.

                    <br/><br/>in encounters you can buy 1-2 gear items for 25 gp, 
                    <br/>in stores you can buy 1 gear item for 25 gp, and a specific gear item for 50gp

                    <br/><br/>They also have a:
                    <ul>
                        <li>40% drop chance in small piles</li>
                        <li>60% in medium piles, with an additional 40% drop chance when the party reaches 6th and 12</li>
                        <li>80% in large piles, with an additional 60% drop chance when the party reaches 6th and 12th.</li>
                    </ul>
                    </p>

                    <h4 style="color:cornflowerblue">UI:</h4>
                    <p
                        >There has been a pretty large update to both GM and player UI's, its mostly self explanatory, however updated pictures and descriptions have been added to the "How To Use Website" section, but its mostly just added tabs to allow for easier sorting and filtering of items, as well as finally giving GM's the ability to look at details for a specific potion or piece of gear.

                        <br/>Players can view gear and potions by clicking the "see items" button instead of "see potions"
                    </p>
                    <h4 style="color:cornflowerblue">Dev Notes:</h4>
                    <p
                        >Adding gear should really help the general balancing for akashic paths, giving minor buffs to both ranged characters and spellcasters which continue to struggle on consistency, but even more importantly it opens up GM's to have more encounters of different types since players will more consistently be able to deal with monsters that are common, but have unbeatable effects if players arent ready, such as flying and invisible creatures. From a programming perspective it also means a large amount of the code needed for things such as scrolls and other types of items like rings and such are already there, so hopefully i can get some of that stuff out soon.
                    </p>
                </v-expansion-panel-content>
            </v-expansion-panel>
            </v-expansion-panels>
        </v-card-text>
        </v-card>
</template>
<script>
import {
VCard,
VCardTitle,
VCardText,
VSpacer,
VExpansionPanels,
VExpansionPanel,
VExpansionPanelHeader,
VExpansionPanelContent,
} from "vuetify/lib";
export default {
  components: {    
    VCard,
    VCardTitle,
    VCardText,
    VSpacer,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent,
  },
}
</script>
